import React from 'react';
import Field, { FieldProps } from '../Field';
import { isSameDay, isDate } from 'date-fns';
import { Datepicker } from '@economic/gaudi';
import { parseFromISOString } from '../../../util/utilities/date';

// 'as' must be an instance, anonymous functions are recreated each render
const DatePickerField = ({ child: Component, calendar, onChange, value, ...fieldProps }) => {
    const valueIsSuggested = value && isSameDay(fieldProps.suggestion, value);

    const calendarProps = {
        showTodayButton: true,
        ...calendar,
        containerProps: {
            ...calendar?.containerProps,
            /*
                When the Datepicker is wrapped inside a <label> element, click events on the calender popover results
                into hiding the popover. The reason is that click events on the calendar propagates to the label, 
                which leads to the click event being propagated to the <Input> associated with the <label>, which will be percieved
                by reakit as a click outside the popover, hence, hiding the popover as a result.
            */
            onClick: (e: React.MouseEvent<HTMLSpanElement>) => e.preventDefault(),
        },
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement> & { detail: any }): void => {
        onChange(event?.detail);
    };

    const valueAsDate = isDate(value) ? value : parseFromISOString(value);

    return (
        <Component
            {...fieldProps}
            calendar={calendarProps}
            highlighted={valueIsSuggested}
            onChange={handleChange}
            style={{ width: '105px' }}
            value={valueAsDate}
            maxLength="10"
        />
    );
};

export default function FieldDatePicker({ as, fieldClassName, ...props }: FieldProps<any>) {
    const Component = as || Datepicker;
    return <Field {...props} as={DatePickerField as any} child={Component} fieldClassName={fieldClassName} />;
}
